module.exports = function getResource(label, vars = []) {
    const resources = {
        subscriptions: 'Subscriptions',
        sorrySubscriptionsUnavailable: 'We’re sorry, subscription services aren’t available in Canada at this time.'
    };

    return resources[label];
};
